import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import { Container, Row, Col, CardGroup, Card, CardBody } from 'reactstrap';
//import { Card, CardBody, CardGroup, Col, Container, Form, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
//import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
//import querystring from 'querystring';

import Lang from '../../languages';

class Login extends Component {
 constructor(props) {
  super(props);
  this.state = { }
 }

 render() {
  return (
   <div className="app flex-row align-items-center">
    <Container>
     <Row className="justify-content-center">
      <Col md="8">
       <CardGroup>
        <Card className="p-4">
         <CardBody>
          <p>{Lang[this.props.session.language].Errors.needsupport}</p>
          <Link to="/login" className="px-0">{Lang[this.props.session.language].Login.backtologin}</Link>
         </CardBody>
        </Card>
       </CardGroup>
      </Col>
     </Row>
    </Container>
   </div>
  );
 }

}

export default Login;



// WEBPACK FOOTER //
// ./websources/views/Auth/Forgotten.js